<h5>{{parte?.title}}</h5>
    <mat-grid-list cols="2" rowHeight="100px" height="400px">
        <mat-grid-tile>
                <mat-form-field appearance="fill" [formGroup]="FormPartesTransporte">
                    <mat-label>PartesTransporte </mat-label>
                    <mat-select name="IdTransporte" formControlName="IdTransporte" (selectionChange)="changeForm($event.value)">
                        <mat-option *ngFor="let part of catalogo" [value]="part?.id">
                            {{part?.attributes?.nombre}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
        </mat-grid-tile>

    </mat-grid-list>
    
    <div class="row">
        <div class="col-sm-12">
            <hr>
        </div>
    </div>
    
 